<!-- IconButton.vue -->
<script setup lang="ts">
  import { IIconButtonProps } from '@/types'
  import loadIcon from '@utils/loadIcon'

  const props = defineProps<IIconButtonProps>()
  const defaultSize = '25'
  const defaultIcon = 'arrow-right-square-fill'
  const onClick = props.onClick ?? (() => {})

  const handleClick = () => {
    onClick()
  }
</script>

<template>
  <button
    class="icon-button system-button"
    @click="handleClick()"
  >
    <i
      class="icon"
      :style="{ fontSize: `${props.size ?? defaultSize}px` }"
      :class="loadIcon(props.icon ?? defaultIcon)"
    />
  </button>
</template>
